import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  Button,
  Modal,
  Input,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import InfoView from '../../components/common/InfoView';

import {
  addTrafficWebsite,
  getTrafficWebsites,
  updateTrafficWebsite,
} from '../../redux/actions/Data';

import { TrafficWebsitesColumns } from './Columns';
import TrafficWebsiteForm from './TrafficWebsiteForm';
import generateQuery, { handleSearch as search } from '../../util/table';
import Can from '../../util/can';
import { DATA_TRAFFIC_WEBSITES } from '../../constants/resources';
import useForm from '../../hooks/useForm';

const TrafficWebsites = () => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);

  const {
    data: trafficWebsitesData,
    loading,
    pageSize,
    currentPage,
    totalRecords,
  } = useSelector(({ data }) => data.trafficWebsites);

  const [searchParams, setSearchParams] = useState('');

  const {
    form,
    onFormOk,
    formVisibility,
    handleShowModal,
    handleCancel,
    handleEditRecord,
    editableRecord,
  } = useForm();

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getTrafficWebsites(pagination));
  }, [dispatch]);

  const editable = Object.keys(editableRecord).length !== 0;

  const handleEditTrafficWebsite = (record) => {
    handleShowModal();
    handleEditRecord(record);
    form.setFieldsValue({
      ...record,
    });
  };

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(getTrafficWebsites(generateQuery(pagination, filters, sorter, searchParams)));
  };

  const handleSearch = (searchValue) => {
    const query = search(
      searchValue.trim().replace(/([^a-zA-Z0-9])/g, '\\$1'),
      dispatch, getTrafficWebsites, TrafficWebsitesColumns, timezone,
    );
    setSearchParams(query);
  };

  const props = {
    loading,
    pagination: {
      current: currentPage,
      pageSize,
      total: totalRecords,
      showSizeChanger: false,
    },
    onChange: handleOnChange,
    rowKey: '_id',
    columns: TrafficWebsitesColumns(
      handleEditTrafficWebsite,
      handleEditRecord,
    ),
    dataSource: trafficWebsitesData,
    scroll: { x: 1300 },
  };

  const handleCancelForm = () => {

  };

  const handleOk = (value) => {
    const trafficWebsiteData = {
      ...value,
    };
    if (editable) {
      dispatch(updateTrafficWebsite(editableRecord._id, trafficWebsiteData));
    } else {
      dispatch(addTrafficWebsite(trafficWebsiteData));
    }
  };

  const handleChange = (value, key) => {
    form.setFieldsValue({
      [key]: value,
    });
  };

  return (
    (
      <div>
        <h2 className="title gx-mb-4">Traffic Websites</h2>
        <div className="gx-d-flex justify-content-center">
          <Can I="create" a={DATA_TRAFFIC_WEBSITES}>
            <Button
              icon={<PlusOutlined />}
              type="primary"
              data-testid="add-transaction-charge-btn"
              onClick={() => handleShowModal()}
            >
              Add Traffic Website
            </Button>

          </Can>
          <Input.Search
            data-testid="search-input"
            placeholder="Search fds cards"
            enterButton
            allowClear
            onSearch={handleSearch}
          />
        </div>
        <div className="gx-d-flex justify-content-center">
          <Table data-testid="fds-cards-table" className="gx-table-responsive" {...props} />
        </div>
        <Modal
          title={editable ? 'Edit Fds Card' : 'Add Fds Card'}
          open={formVisibility}
          okText={editable ? 'Save' : 'Add'}
          onOk={() => onFormOk(handleOk)}
          confirmLoading={loading}
          onCancel={() => {
            handleCancel();
            handleCancelForm();
          }}
          width={1000}
        >
          <TrafficWebsiteForm {...{
            form,
            handleChange,
          }}
          />
        </Modal>
        <InfoView />
      </div>
    )
  );
};

export default TrafficWebsites;
